<template>
    <div>
        <Breadcrumbs main="Dashboard" title="Six4D Lottery" />
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-xl-12 xl-100">
                    <div class="row">
                        <div class="col-lg-12" v-if="canViewCloudflare">
                            <div class="card">
                                <div class="card-header d-flex justify-content-between align-items-center">
                                    <div>
                                        <h5>Website Traffic Statistics</h5>
                                        <span>Last {{ cloudflare.hours }} hours</span>
                                    </div>
                                    <button class="btn btn-outline-primary btn-sm" @click="fetchCloudflareStats" :disabled="cloudflare.loading">
                                        Refresh
                                    </button>
                                </div>
                                <div class="card-body">
                                    <div v-if="cloudflare.errorMessage" class="alert alert-danger" role="alert">
                                        {{ cloudflare.errorMessage }}
                                    </div>
                                    <div class="row" v-else>
                                        <div class="col-md-3 col-6">
                                            <h6 class="mb-1">Total Requests</h6>
                                            <h4 class="mb-0">{{ formatNumber(cloudflare.stats.totalRequests) }}</h4>
                                        </div>
                                        <div class="col-md-3 col-6">
                                            <h6 class="mb-1">Unique Visitors</h6>
                                            <h4 class="mb-0">{{ formatNumber(cloudflare.stats.uniqueVisitors) }}</h4>
                                        </div>
                                        <div class="col-md-3 col-6 mt-3 mt-md-0">
                                            <h6 class="mb-1">Bandwidth</h6>
                                            <h4 class="mb-0">{{ formatBytes(cloudflare.stats.totalBandwidthBytes) }}</h4>
                                        </div>
                                        <div class="col-md-3 col-6 mt-3 mt-md-0">
                                            <h6 class="mb-1">Threats</h6>
                                            <h4 class="mb-0">{{ formatNumber(cloudflare.stats.threats) }}</h4>
                                        </div>
                                        <div class="col-md-3 col-6 mt-3">
                                            <h6 class="mb-1">Cached Requests</h6>
                                            <h4 class="mb-0">{{ formatNumber(cloudflare.stats.cachedRequests) }}</h4>
                                        </div>
                                        <div class="col-md-3 col-6 mt-3">
                                            <h6 class="mb-1">Cached Bandwidth</h6>
                                            <h4 class="mb-0">{{ formatBytes(cloudflare.stats.cachedBandwidthBytes) }}</h4>
                                        </div>
                                        <div class="col-md-6 mt-3">
                                            <h6 class="mb-1">Cache Hit Ratio</h6>
                                            <h4 class="mb-0">{{ cacheHitRatio }}%</h4>
                                        </div>
                                        <div class="col-12 mt-4" v-if="cloudflareTrend.chartData.labels.length">
                                            <div class="d-flex justify-content-between align-items-center mb-2">
                                                <h6 class="mb-0">24h Request Trend</h6>
                                                <small class="text-muted">Total vs Cached Requests</small>
                                            </div>
                                            <chartist
                                                ratio="ct-golden-section"
                                                type="Line"
                                                :data="cloudflareTrend.chartData"
                                                :options="cloudflareTrend.chartOptions"
                                            />
                                        </div>
                                    </div>
                                    <div class="text-muted mt-3 small" v-if="cloudflare.lastUpdated">
                                        Last updated: {{ formatDate(cloudflare.lastUpdated) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="card">
                                <div class="card-body">
                                    <div class="chart-widget-dashboard">
                                        <div class="d-flex">
                                            <div class="flex-grow-1">
                                                <h5 class="mt-0 mb-0 f-w-600">
                                                    <vue-feather type="dollar-sign" /><span class="counter">5789</span>
                                                </h5>
                                                <p>Total Visits</p>
                                            </div>
                                            <vue-feather type="tag" />
                                        </div>
                                        <div class="dashboard-chart-container">
                                            <div class="small-chart-gradient-1">
                                                <chartist ratio="ct-major-second" type="Line" :data="chart.chartData_1"
                                                    :options="chart.chartOptions" :event-handlers="chart.eventHandlers">
                                                </chartist>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="card">
                                <div class="card-body">
                                    <div class="chart-widget-dashboard">
                                        <div class="d-flex">
                                            <div class="flex-grow-1">
                                                <h5 class="mt-0 mb-0 f-w-600">
                                                    <vue-feather type="dollar-sign" /><span class="counter">4986</span>
                                                </h5>
                                                <p>Total Sale</p>
                                            </div>
                                            <vue-feather type="shopping-cart" />
                                        </div>
                                        <div class="dashboard-chart-container">
                                            <div class="small-chart-gradient-1">
                                                <chartist ratio="ct-major-second" type="Line" :data="chart.chartData_2"
                                                    :options="chart.chartOptions" :event-handlers="chart.eventHandlers">
                                                </chartist>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="card">
                                <div class="card-body">
                                    <div class="chart-widget-dashboard">
                                        <div class="d-flex">
                                            <div class="flex-grow-1">
                                                <h5 class="mt-0 mb-0 f-w-600">
                                                    <vue-feather type="dollar-sign" /><span class="counter">8568</span>
                                                </h5>
                                                <p>Total Value</p>
                                            </div>
                                            <vue-feather type="sun" />
                                        </div>
                                        <div class="dashboard-chart-container">
                                            <div class="small-chart-gradient-1">
                                                <chartist ratio="ct-major-second" type="Line" :data="chart.chartData_3"
                                                    :options="chart.chartOptions" :event-handlers="chart.eventHandlers">
                                                </chartist>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <div class="card">
                                <div class="card-header">
                                    <h5>Production Valuation</h5>
                                </div>
                                <div class="card-body">
                                    <div class="show-value-top d-flex">
                                        <div class="value-left d-inline-block">
                                            <div class="square bg-primary d-inline-block"></div><span>Total Earning</span>
                                        </div>
                                        <div class="value-right d-inline-block">
                                            <div class="square d-inline-block bg-secondary"></div><span>Total Tax</span>
                                        </div>
                                    </div>
                                    <chartist ratio="ct-major-first" type="Line" :data="smooth_chart.chartData"
                                        :options="smooth_chart.chartOptions" :event-handlers="smooth_chart.eventHandlers" />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="col-xl-4 xl-100">
                    <div class="card">
                        <div class="card-header">
                            <h5>Total Profit</h5><span class="d-block fonts-dashboard">All Custom Income</span>
                        </div>
                        <div class="card-body">
                            <div class="text-center">
                                <div class="knob" id="profit">
                                    <apexchart height="270" type="radialBar" :options="chartData_4.chartOptions"
                                        :series="chartData_4.series"></apexchart>
                                </div>
                            </div>
                            <div class="show-value d-flex">
                                <div class="value-left">
                                    <div class="square bg-primary d-inline-block"></div><span>Total Profit</span>
                                </div>
                                <div class="value-right">
                                    <div class="square bg-light d-inline-block"></div><span>Total Investment</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 xl-50 col-md-6">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card">
                                <div class="card-body progress-media">
                                    <div class="d-flex">
                                        <div class="flex-grow-1">
                                            <h5>Total Review</h5><span class="mb-0 d-block">Customer Review</span>
                                        </div>
                                        <vue-feather type="thumbs-up" />
                                    </div>
                                    <div class="progress-bar-showcase">
                                        <div class="progress sm-progress-bar">
                                            <div class="progress-bar bg-primary" role="progressbar" style="width: 90%"
                                                aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                    <div class="progress-change"><span>Change</span><span class="pull-right">95%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="card">
                                <div class="card-body progress-media">
                                    <div class="d-flex">
                                        <div class="flex-grow-1">
                                            <h5>Total Feedback</h5><span class="mb-0 d-block">Feedback</span>
                                        </div>
                                        <vue-feather type="message-circle" />
                                    </div>
                                    <div class="progress-bar-showcase">
                                        <div class="progress sm-progress-bar">
                                            <div class="progress-bar bg-primary" role="progressbar" style="width: 85%"
                                                aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                    <div class="progress-change"><span>Change</span><span class="pull-right">85%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 xl-50 col-md-6">
                    <div class="card user-card">
                        <div class="card-body">
                            <div class="online-user">
                                <h5 class="font-primary f-18 mb-0">Online</h5>
                            </div>
                            <div class="user-card-image"><img class="img-fluid rounded-circle image-radius"
                                    src='@/assets/images/dashboard/designer.jpg' alt=""></div>
                            <div class="user-deatils text-center">
                                <h5>Marshi Kisteen</h5>
                                <h6 class="mb-0">marshikisteen@gmail.com</h6>
                            </div>
                            <div class="user-badge text-center"><a class="badge badge-pill badge-light rounded-pill"
                                    href="#">Dashboard</a><a class="badge badge-pill badge-light rounded-pill" href="#">Ui</a><a
                                    class="badge badge-pill badge-light rounded-pill" href="#">Xi</a><a href="#"><span
                                        class="badge badge-pill badge-light active">2+</span></a></div>
                            <div class="card-footer row pb-0 text-center">
                                <div class="col-6 p-0">
                                    <div class="d-flex user-footer">
                                        <vue-feather class="m-r-10" type="message-square" />
                                        <h6 class="f-18 mb-0">Message</h6>
                                    </div>
                                </div>
                                <div class="col-6 p-0">
                                    <div class="d-flex user-footer">
                                        <vue-feather class="m-r-10" type="briefcase" />
                                        <h6 class="f-18 mb-0">Portfolio</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="card">
                        <div class="card-header card-header-border">
                            <div class="row">
                                <div class="col-sm-6">
                                    <h5>New User</h5>
                                </div>
                                <div class="col-sm-6">
                                    <div class="pull-right right-header"><span>Month</span><span>
                                            <button class="btn btn-primary btn-pill">Today</button></span></div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="new-users">
                                <div class="d-flex"><img class="rounded-circle image-radius m-r-15"
                                        src="@/assets/images/user/2.png" alt="">
                                    <div class="flex-grow-1">
                                        <h6 class="mb-0 f-w-700">Nick Stone</h6>
                                        <p>Visual Designer, Github Inc</p>
                                    </div><span class="pull-right">
                                        <button class="btn btn-pill btn-outline-light">Follow</button></span>
                                </div>
                                <div class="d-flex"><img class="rounded-circle image-radius m-r-15"
                                        src="@/assets/images/user/5.jpg" alt="">
                                    <div class="flex-grow-1">
                                        <h6 class="mb-0 f-w-700">Milano Esco</h6>
                                        <p>Visual Designer, Github Inc</p>
                                    </div><span class="pull-right">
                                        <button class="btn btn-pill btn-outline-light">Follow</button></span>
                                </div>
                                <div class="d-flex"><img class="rounded-circle image-radius m-r-15"
                                        src="@/assets/images/user/3.jpg" alt="">
                                    <div class="flex-grow-1">
                                        <h6 class="mb-0 f-w-700">Wiltor Noice</h6>
                                        <p>Visual Designer, Github Inc</p>
                                    </div><span class="pull-right">
                                        <button class="btn btn-pill btn-outline-light">Follow</button></span>
                                </div>
                                <div class="d-flex"><img class="rounded-circle image-radius m-r-15"
                                        src="@/assets/images/user/4.jpg" alt="">
                                    <div class="flex-grow-1">
                                        <h6 class="mb-0 f-w-700">Anna Strong</h6>
                                        <p>Visual Designer, Github Inc</p>
                                    </div><span class="pull-right">
                                        <button class="btn btn-pill btn-outline-light">Follow</button></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="card">
                        <div class="card-header card-header-border">
                            <div class="row">
                                <div class="col-sm-7">
                                    <h5>Recent Notification</h5>
                                </div>
                                <div class="col-sm-5">
                                    <div class="pull-right right-header">
                                        <div class="onhover-dropdown">
                                            <button class="btn btn-primary btn-pill" type="button">All <span class="p-0"><i
                                                        class="fa fa-angle-down" /></span></button>
                                            <div class="onhover-show-div right-header-dropdown"><a class="d-block"
                                                    href="#">Order</a><a class="d-block" href="#">Download</a><a
                                                    class="d-block" href="#">Trash</a></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body recent-notification">
                            <div class="d-flex">
                                <h6>09:00</h6>
                                <div class="flex-grow-1"><span>Lorem ipsum dolor sit amit,consectetur eiusmdd.</span>
                                    <p class="f-12">By Kan</p>
                                </div>
                            </div>
                            <div class="d-flex">
                                <h6>10:50</h6>
                                <div class="flex-grow-1"><span>Lorem ipsum.</span>
                                    <p class="f-12">By Tailer</p>
                                </div>
                            </div>
                            <div class="d-flex">
                                <h6>01:00</h6>
                                <div class="flex-grow-1"><span>Lorem ipsum dolor sit amit,consectetur eiusmdd.</span>
                                    <p class="f-12">By Kaint</p>
                                </div>
                            </div>
                            <div class="d-flex">
                                <h6>05:00</h6>
                                <div class="flex-grow-1"><span>Lorem ipsum dolor sit amit.</span>
                                    <p class="f-12">By call</p>
                                </div>
                            </div>
                            <div class="d-flex">
                                <h6>12:00</h6>
                                <div class="flex-grow-1"><span>Lorem ipsum dolor sit.</span>
                                    <p class="f-12">By Waiter</p>
                                </div>
                            </div>
                            <div class="d-flex">
                                <h6>08:20</h6>
                                <div class="flex-grow-1"><span>Lorem ipsum dolor sit amit,consectetur eiusmdd dolor sit
                                        amit.</span>
                                    <p class="f-12">By Comman</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-header">
                            <h5>Calculation</h5>
                        </div>
                        <div class="card-body">
                            <div class="show-value-top d-flex">
                                <div class="value-left d-inline-block">
                                    <div class="square bg-primary d-inline-block"></div><span>Total Income</span>
                                </div>
                                <div class="value-right d-inline-block">
                                    <div class="square d-inline-block bg-smooth-chart"></div><span>Total Loss</span>
                                </div>
                            </div>
                            <chartist class="ct-svg flot-chart-container" ratio="ct-major-different" type="Line"
                                :data="line_chart.chartData" :options="line_chart.chartOptions"
                                :event-handlers="line_chart.eventHandlers">
                            </chartist>
                        </div>
                    </div>
                </div>
                <div class="col-xl-7 xl-100">
                    <div class="card">
                        <div class="card-header card-header-border">
                            <div class="row">
                                <div class="col-sm-6">
                                    <h5>Conversations</h5>
                                </div>
                                <div class="col-sm-6">
                                    <div class="right-header pull-right m-t-5">
                                        <div class="onhover-dropdown">
                                            <vue-feather type="more-horizontal" />
                                            <div class="onhover-show-div right-header-dropdown more-dropdown"><a
                                                    class="d-block" href="#">View</a><a class="d-block" href="#">Media</a><a
                                                    class="d-block" href="#">Search</a></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body chat-box dashboard-chat">
                            <div class="chat">
                                <div class="d-flex left-side-chat"><img class="rounded-circle chat-user-img img-60 m-r-20"
                                        src="@/assets/images/user/4.jpg" alt="">
                                    <div class="flex-grow-1">
                                        <div class="message-main">
                                            <p class="mb-0">Lorem Ipsum is simply dummy text of the </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex right-side-chat">
                                    <div class="flex-grow-1 text-end">
                                        <div class="message-main">
                                            <p class="pull-right">Lorem Ipsum is simply dummy text of the printing and Lorem
                                                Ipsum has been the industry's</p>
                                            <div class="clearfix"></div>
                                        </div>
                                        <div class="sub-message message-main">
                                            <p class="pull-right mb-0">Lorem Ipsum is simply dummy text of the </p>
                                            <div class="clearfix"></div>
                                        </div>
                                    </div><img class="rounded-circle chat-user-img img-60 m-l-20"
                                        src="@/assets/images/user/5.jpg" alt="">
                                </div>
                                <div class="d-flex left-side-chat"><img class="rounded-circle chat-user-img img-60 m-r-20"
                                        src="@/assets/images/user/4.jpg" alt="">
                                    <div class="flex-grow-1">
                                        <div class="message-main">
                                            <p>Lorem Ipsum is simply dummy text of the printing</p>
                                        </div>
                                        <div class="sub-message message-main smiley-bg"><img
                                                src="@/assets/images/dashboard/smily.png" alt=""></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex chat-footer bg-primary"><i class="icon-face-smile" />
                            <div class="flex-grow-1">
                                <input class="form-control" type="text" placeholder="Type your message" required="">
                            </div>
                            <vue-feather type="send" class="pr-0" />
                        </div>
                    </div>
                </div>
                <div class="col-xl-5 xl-100">
                    <div class="card">
                        <div class="card-header card-header-border">
                            <div class="row">
                                <div class="col-sm-6">
                                    <h5>Selling Update</h5>
                                </div>
                                <div class="col-sm-6">
                                    <div class="pull-right right-header">
                                        <div class="onhover-dropdown">
                                            <button class="btn btn-primary btn-pill" type="button">All <span class="p-0"><i
                                                        class="fa fa-angle-down" /></span></button>
                                            <div class="onhover-show-div right-header-dropdown"><a class="d-block"
                                                    href="#">Shipping</a><a class="d-block" href="#">Purchase</a><a
                                                    class="d-block" href="#">Total Sell</a></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="selling-update text-center">
                                        <vue-feather type="activity" />
                                        <h5 class="mb-0 f-18">+500</h5>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="selling-update text-center">
                                        <vue-feather type="anchor" />
                                        <h5 class="mb-0 f-18">+120</h5>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="selling-update text-center">
                                        <vue-feather type="box" />
                                        <h5 class="mb-0 f-18">-410</h5>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="selling-update text-center">
                                        <vue-feather type="book" />
                                        <h5 class="mb-0 f-18">-155</h5>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="selling-update text-center">
                                        <vue-feather type="compass" />
                                        <h5 class="mb-0 f-18">+920</h5>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="selling-update text-center">
                                        <vue-feather type="cpu" />
                                        <h5 class="mb-0 f-18">+500</h5>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="selling-update text-center mb-0 xs-mb-selling">
                                        <vue-feather type="dollar-sign" />
                                        <h5 class="mb-0 f-18">+500</h5>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="selling-update text-center mb-0 xs-mb-selling">
                                        <vue-feather type="slack" />
                                        <h5 class="mb-0 f-18">+120</h5>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="selling-update text-center mb-0">
                                        <vue-feather type="umbrella" />
                                        <h5 class="mb-0 f-18">-410</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>
<script>
import { API_BASE } from '../../config/api';
var primary = localStorage.getItem('primary_color') || '#4466f2';
var secondary = localStorage.getItem('secondary_color') || '#1ea6ec';

import * as Chartist from 'chartist';
export default {
    data() {
        return {
            cloudflare: {
                hours: 24,
                loading: false,
                errorMessage: '',
                lastUpdated: '',
                stats: {
                    totalRequests: 0,
                    uniqueVisitors: 0,
                    totalBandwidthBytes: 0,
                    cachedRequests: 0,
                    cachedBandwidthBytes: 0,
                    threats: 0,
                }
            },
            cloudflareTrend: {
                chartData: {
                    labels: [],
                    series: [[], []]
                },
                chartOptions: {
                    fullWidth: true,
                    showArea: false,
                    showPoint: true,
                    chartPadding: {
                        right: 12,
                        left: -8,
                        bottom: -8
                    },
                    axisY: {
                        onlyInteger: true,
                        low: 0
                    },
                    axisX: {
                        showGrid: false
                    },
                    lineSmooth: Chartist.Interpolation.simple({ divisor: 2 })
                }
            },
            chart: {
                chartData_1: {
                    labels: ['01', '02', '03', '04', '05', '06', '07'],
                    series: [
                        [0, 2, 1.2, 4, 2, 3, 1.5, 0]
                    ],
                },
                chartData_2: {
                    labels: ['01', '02', '03', '04', '05', '06'],
                    series: [
                        [0, 2, 1.2, 4, 2, 3, 0]
                    ]
                },
                chartData_3: {
                    labels: ['01', '02', '03', '04', '05', '06', '07'],
                    series: [
                        [0, 2, 1.2, 4, 2, 3, 1.5, 2, 0]
                    ]
                },

                chartOptions: {
                    // lineSmooth: true,
                    lineSmooth: Chartist.Interpolation.simple({ divisor: 2 }),
                    fullWidth: true,
                    showArea: !0,
                    showPoint: false,
                    chartPadding: {
                        right: 0,
                        left: 0,
                        bottom: 0,
                    },
                    axisY: {
                        low: 0,
                        showGrid: false,
                        showLabel: false,
                        offset: 0
                    },
                    axisX: {
                        showGrid: false,
                        showLabel: false,
                        offset: 0
                    },
                },
                eventHandlers: [{
                    event: 'created',
                    fn(data) {
                        var defs = data.svg.elem('defs');
                        defs.elem('linearGradient', {
                            id: 'gradient2',
                            x1: 1,
                            y1: 1,
                            x2: 0,
                            y2: 0
                        }).elem('stop', {
                            offset: 0,
                            'stop-color': primary
                        }).parent().elem('stop', {
                            offset: 1,
                            'stop-color': secondary
                        });
                    }
                }]

            },
            chartData_4: {
                series: [35],
                chartOptions: {
                    chart: {
                        height: 270,
                        type: 'radialBar',
                    },
                    plotOptions: {
                        radialBar: {
                            hollow: {
                                size: '70%',
                            },
                            dataLabels: {
                                name: {
                                    show: false,
                                    color: '#fff'
                                },
                                value: {
                                    show: true,
                                    color: '#333',
                                    offsetY: 10,
                                    fontSize: '22px'
                                }
                            }
                        },
                    },
                    labels: [''],
                    colors: [primary],
                },

            },
            smooth_chart: {
                chartData: {
                    labels: ['2009', '2010', '2011', '2012'],
                    series: [
                        [0, 60, 20, 60],
                        [0, 70, 10, 80]
                    ]
                },
                chartOptions: {
                    height: '358px',
                    fullWidth: true,
                    offset: -5,
                    low: 0,
                    chartPadding: {
                        right: 0,
                        left: -15,
                        top: 0,
                        bottom: -15
                    }
                },
                eventHandlers: [{
                    event: 'created',
                    fn(data) {
                        var defs = data.svg.elem('defs');
                        defs.elem('linearGradient', {
                            id: 'gradient1',
                            x1: 0,
                            y1: 0,
                            x2: 1,
                            y2: 1
                        }).elem('stop', {
                            offset: 0,
                            'stop-color': primary
                        }).parent().elem('stop', {
                            offset: 1,
                            'stop-color': secondary
                        });
                    }
                }]
            },
            line_chart: {
                chartData: {
                    labels: ['01', '02', '03', '04', '05', '06', '07', '08'],
                    series: [
                        [0, 2, 1.2, 4, 2, 3, 1.5, 0],
                        [0, 1, 2.2, 1.5, 3, 1.5, 2.25, 0]
                    ]
                },
                chartOptions: {
                    low: 0,
                    chartPadding: {
                        right: 0,
                        left: -15,
                        top: 0,
                        bottom: -15
                    },
                    showArea: true,
                    fullWidth: true,
                    onlyInteger: true,

                    axisY: {
                        low: 0,
                        scaleMinSpace: 50,
                    },
                    axisX: {
                        showGrid: false
                    }
                },
                eventHandlers: [{
                    event: 'created',
                    fn(data) {
                        var defs = data.svg.elem('defs');
                        defs.elem('linearGradient', {
                            id: 'gradient1',
                            x1: 0,
                            y1: 0,
                            x2: 1,
                            y2: 1
                        }).elem('stop', {
                            offset: 0,
                            'stop-color': primary
                        }).parent().elem('stop', {
                            offset: 1,
                            'stop-color': secondary
                        });
                    }
                }]
            }
        }
    },
    computed: {
        permissions() {
            return this.$store?.state?.auth?.permissions || [];
        },
        canViewCloudflare() {
            return this.permissions.includes('systems:read');
        },
        cacheHitRatio() {
            const total = Number(this.cloudflare.stats.totalRequests || 0);
            const cached = Number(this.cloudflare.stats.cachedRequests || 0);
            if (total <= 0) {
                return '0.00';
            }

            return ((cached / total) * 100).toFixed(2);
        }
    },
    methods: {
        async fetchCloudflareStats() {
            this.cloudflare.loading = true;
            this.cloudflare.errorMessage = '';

            try {
                const response = await fetch(`${API_BASE}/api/Cloudflare/stats?hours=${this.cloudflare.hours}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`,
                        'Content-Type': 'application/json'
                    }
                });

                const payload = await response.json();
                if (!response.ok) {
                    this.cloudflare.errorMessage = payload?.message || `Failed to load Cloudflare stats (${response.status}).`;
                    return;
                }

                this.cloudflare.stats = {
                    totalRequests: payload.totalRequests || 0,
                    uniqueVisitors: payload.uniqueVisitors || 0,
                    totalBandwidthBytes: payload.totalBandwidthBytes || 0,
                    cachedRequests: payload.cachedRequests || 0,
                    cachedBandwidthBytes: payload.cachedBandwidthBytes || 0,
                    threats: payload.threats || 0,
                };
                this.setCloudflareTrend(payload.timeseries || []);
                this.cloudflare.lastUpdated = new Date().toISOString();
            } catch (error) {
                this.cloudflare.errorMessage = error?.message || 'Unable to fetch Cloudflare statistics.';
            } finally {
                this.cloudflare.loading = false;
            }
        },
        setCloudflareTrend(timeseries) {
            if (!Array.isArray(timeseries) || !timeseries.length) {
                this.cloudflareTrend.chartData = {
                    labels: [],
                    series: [[], []]
                };
                return;
            }

            const points = [...timeseries].sort((a, b) => new Date(a.sinceUtc) - new Date(b.sinceUtc));
            const labels = points.map((point) => {
                const date = new Date(point.sinceUtc);
                return Number.isNaN(date.getTime())
                    ? '-'
                    : `${String(date.getHours()).padStart(2, '0')}:00`;
            });
            const totalSeries = points.map((point) => Number(point.requests || 0));
            const cachedSeries = points.map((point) => Number(point.cachedRequests || 0));

            this.cloudflareTrend.chartData = {
                labels,
                series: [totalSeries, cachedSeries]
            };
        },
        formatNumber(value) {
            return Number(value || 0).toLocaleString('en-GB');
        },
        formatBytes(value) {
            const bytes = Number(value || 0);
            if (bytes <= 0) return '0 B';
            const units = ['B', 'KB', 'MB', 'GB', 'TB'];
            const idx = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
            const normalized = bytes / Math.pow(1024, idx);
            return `${normalized.toFixed(idx === 0 ? 0 : 2)} ${units[idx]}`;
        },
        formatDate(value) {
            if (!value) return '-';
            const date = new Date(value);
            if (Number.isNaN(date.getTime())) return '-';
            return date.toLocaleString('en-GB');
        }
    },
    mounted() {
        document.getElementById('profit')
        if (this.canViewCloudflare) {
            this.fetchCloudflareStats();
        }
    }

}
</script>
<style>
div.review canvas {
    position: relative !important;
}

div.review input {
    z-index: 1;
    display: inline-block;
}
</style>
